import { Promise, append, addClass, remove, putOnMap, deleteFromMap, off, window, on, getFromMap, parentElement, hasClass, existsOnMap, setTimeout, clearTimeout, removeClass, sizeOfMap, createMap, animate, scrollIntoView, query, createElement, createSet, addToSet, clearSet, CLICK_EVENT, getEventTarget, hasAttribute, } from "@acng/frontend-bounty";
export const containerSymbol = Symbol();
const CSS_MODAL = "popup-modal";
const CSS_EMPTY = "popup-empty";
const CSS_CLOSE = "popup-close";
const CSS_NEGLECT = "popup-neglect";
/**
 * @todo TODO make configurable or change to "message-text" / EXPORT/IMPORT for this class
 */
const CSS_MESSAGE_TEXT = "popup-message"; // TODO this should be an Element.id which is removed from the template clone
let CSS_MESSAGE_INFO = ["info"];
let CSS_MESSAGE_WARN = ["warn"];
let CSS_MESSAGE_ERROR = ["error"];
const SELECT_MESSAGE = `.${CSS_MESSAGE_TEXT}`;
let MESSAGE_TEMPLATE_LOADER = () => createElement('p');
export const setMessageTemplateLoader = (loader) => void (MESSAGE_TEMPLATE_LOADER = loader);
export const setMessageClassList = (info, warn, error) => {
    CSS_MESSAGE_INFO = info;
    CSS_MESSAGE_WARN = warn;
    CSS_MESSAGE_ERROR = error;
};
export function createPopupController() {
    let modalCount = 0;
    let container;
    const onLeaveDefault = (child) => animate(child, [{ opacity: "1" }, { opacity: "0" }], { duration: 250 }).finished;
    const onEnterDefault = (child) => animate(child, [{ opacity: "0" }, { opacity: "1" }], { duration: 250 }).finished;
    const map = createMap();
    const deferred = createSet();
    const show = (child, modal, onEnter, onLeave) => {
        return new Promise(function retry(resolve) {
            DEBUG: if (container) {
                if (hasAttribute(container, 'debug'))
                    console.info("discovery/popup show", { container, child });
            }
            else {
                console.warn("discovery/popup show", { container, child });
            }
            if (!container) {
                addToSet(deferred, () => retry(resolve));
                return;
            }
            let timeout;
            const close = async (value) => {
                DEBUG: if (container && hasAttribute(container, 'debug'))
                    console.assert(container instanceof HTMLElement, "container must be set");
                if (timeout) {
                    clearTimeout(timeout);
                }
                else {
                    off(window, CLICK_EVENT, globalClickHandler);
                }
                DEBUG: if (container && hasAttribute(container, 'debug'))
                    console.debug("discovery/popup close", { container, child, value });
                await (onLeave ?? onLeaveDefault)(child);
                remove(child);
                deleteFromMap(map, child);
                if (modal && !--modalCount) {
                    removeClass(container, CSS_MODAL);
                }
                if (!sizeOfMap(map)) {
                    addClass(container, CSS_EMPTY);
                }
                DEBUG: if (container && hasAttribute(container, 'debug'))
                    console.debug("discovery/popup closed", { container, child, value });
                resolve(value);
            };
            const globalClickHandler = (evt) => {
                for (let p = getEventTarget(evt); p; p = parentElement(p)) {
                    if (p === child) {
                        return;
                    }
                }
                close(evt);
            };
            const childClickHandler = (evt) => {
                for (let p = getEventTarget(evt); p; p = parentElement(p)) {
                    if (hasClass(p, CSS_CLOSE)) {
                        close(evt);
                        return;
                    }
                    if (p === child) {
                        return;
                    }
                }
            };
            append(container, child);
            scrollIntoView(child, { behavior: "smooth", block: "nearest" });
            putOnMap(map, child, close);
            on(child, CLICK_EVENT, childClickHandler);
            removeClass(container, CSS_EMPTY);
            if (modal) {
                modalCount++;
                addClass(container, CSS_MODAL);
            }
            else {
                // TODO make timeout interval parameter/config
                timeout = setTimeout(() => {
                    timeout = undefined;
                    addClass(child, CSS_NEGLECT);
                    on(window, CLICK_EVENT, globalClickHandler);
                }, 5000);
            }
            (onEnter ?? onEnterDefault)(child);
        });
    };
    const message = async (message, ...tokens) => {
        const element = await MESSAGE_TEMPLATE_LOADER();
        addClass(element, CSS_CLOSE, ...tokens);
        DEBUG: if (container && hasAttribute(container, 'debug'))
            console.info("discovery/popup message", { container, message, element });
        append(query(SELECT_MESSAGE, element) ?? element, message);
        await show(element, false);
    };
    return {
        setContainer: (element) => {
            if (container) {
                if (element) {
                    // TODO ? take over or not ?
                    DEBUG: if (hasAttribute(element, 'debug'))
                        console.warn('discovery/popup container change', { old: container, new: element });
                    //throw Error("container change is not supported");
                }
            }
            container = element;
            if (!container) {
                // TODO close all
                return;
            }
            for (const showDeffered of deferred) {
                showDeffered();
            }
            clearSet(deferred);
        },
        show: (element, onEnter, onLeave) => show(element, false, onEnter, onLeave),
        showModal: (element, onEnter, onLeave) => show(element, true, onEnter, onLeave),
        isOpen: (element) => existsOnMap(map, element),
        close: (element, returnValue) => {
            const closeFn = getFromMap(map, element);
            if (!closeFn || closeFn === true) {
                throw Error("not found");
            }
            return closeFn(returnValue);
        },
        info: (text) => message(text, ...CSS_MESSAGE_INFO),
        warn: (text) => message(text, ...CSS_MESSAGE_WARN),
        error: (text) => message(text, ...CSS_MESSAGE_ERROR),
        // TODO destroy: () => { remove all elements and reject all promises }
    };
}
